import React, {FC, ReactElement} from "react";
import {Grid, Typography} from "@mui/material";
import {Trans} from "react-i18next";

interface IProps {

}

export const AdviceView: FC<IProps> = (): ReactElement => {
    return <>
        <Grid item container xs={12} spacing={1} pl={2}>
            <Grid item>
                <Typography variant="h6">
                    <Trans i18nKey="advice.use_chat">
                        If you have any questions - please use the chat button in the right corner to get support.
                    </Trans>
                </Typography>
            </Grid>
        </Grid>
    </>;
};